/* Custom Flat List with Offer Form - Works like Flat Search */
(function ($) {
  "use strict";

  if (!$(".js-custom-flat-table").length) {
    return;
  }

  // Initialize lakaskereso.selected if doesn't exist
  if (!$.lakaskereso) {
    $.lakaskereso = { selected: [] };
  }

  // Use the same selected array as lakaskereso
  let customSelectedFlats = [];

  // Remove js-open-offer-modal class from custom offer button
  // to prevent delayed-main.js from opening the modal automatically
  $(".js-custom-offer-button").removeClass("js-open-offer-modal");

  // Update selected counter
  function updateSelectedCounter() {
    const count = customSelectedFlats.length;
    const text =
      count > 0
        ? `(${count} ${
            $.pluralize
              ? $.pluralize(localize.translations.flat, count)
              : localize.translations.flat
          })`
        : "";

    $(".js-custom-selected-flats").text(text);
  }

  // Sync with lakaskereso
  function syncWithLakaskereso() {
    $.lakaskereso.selected = [...customSelectedFlats];
  }

  // Update modal with selected flats (exactly like lakaskereso does)
  function updateModalSelectedFlats() {
    // Show the wrappers
    $(".js-which-flat").show();
    $(".js-offer-rooms").hide();
    $(".js-offer-rooms select").prop("required", false);

    // Hide the residential wrapper (since we have pre-selected ones)
    $(".js-which-residential-wrapper").addClass("d-none");
    $(".js-which-residential-wrapper-title").addClass("d-none");

    // Collect unique residential names and flat names
    const residentials = [];
    const flats = [];
    const flatIds = []; // Eredeti flat ID-k gyűjtése
    const roomNumbers = []; // Szobaszámok gyűjtése

    customSelectedFlats.forEach((flatId) => {
      const checkbox = $(`#${flatId}`);
      const row = checkbox.closest(".js-custom-flat-row");
      const residential = row.data("residential-title") || "";
      const flatName =
        row.data("flat-name") || checkbox.data("flat-name") || "";
      const actualFlatId = row.data("actual-flat-id") || ""; // Eredeti flat ID
      const roomNumber = row.data("room-number") || ""; // Szobaszám

      if (residential && !residentials.includes(residential)) {
        residentials.push(residential);
      }
      if (flatName) {
        flats.push(flatName);
      }
      if (actualFlatId) {
        flatIds.push(actualFlatId);
      }
      if (roomNumber && !roomNumbers.includes(roomNumber)) {
        roomNumbers.push(roomNumber);
      }
    });

    // Update modal content (same as lakaskereso lines 996-1012)
    const residentialNames = residentials.join(", ");
    const flatNames = flats.join(", ");

    $(".js-selected-offer-residentials strong").html(residentialNames);
    $(".js-selected-offer-residentials").show();

    $(".js-selected-offer-flats strong").html(flatNames);
    $(".js-selected-offer-flats").show();

    // Clear previous hidden inputs for custom flat list AND all flatname inputs
    $("#offer-form input[data-custom-flat-list]").remove();
    $("#offer-form input[name='flatname']").remove();

    // Note: residential[] and flat[] are handled by selects, not hidden inputs

    // Add hidden input for rooms (szobaszámok pontosvesszővel elválasztva)
    if (roomNumbers.length > 0) {
      const roomsString = roomNumbers.join(";"); // "2;3" formátum
      $("#offer-form").append(
        `<input type="hidden" name="rooms" value="${$("<div>")
          .text(roomsString)
          .html()}" data-custom-flat-list="true">`,
      );
    }

    // Store flat names globally for form submission (for compatibility)
    window.customFlatNames = flats;

    // Populate #which-residential select with residential names (for delayed-main.js compatibility)
    // The option value is the residential name, which will be submitted as residential[] parameter
    if ($("#which-residential").length && $("#which-residential")[0].sumo) {
      $("#which-residential")[0].sumo.unSelectAll();
      $("#which-residential").empty();

      // Add residential names as selected options
      residentials.forEach((residential, index) => {
        $("#which-residential").append(
          `<option value="${$("<div>").text(residential).html()}" selected>${$(
            "<div>",
          )
            .text(residential)
            .html()}</option>`,
        );
      });

      $("#which-residential")[0].sumo.reload();
    }

    // Reload other sumo selects
    if ($("#price").length && $("#price")[0].sumo) {
      $("#price")[0].sumo.reload();
    }

    // Populate #which-flat select with flat names (for delayed-main.js compatibility)
    // The option value is the actual flat ID, which will be submitted as flat[] parameter
    if ($("#which-flat").length && $("#which-flat")[0].sumo) {
      // Clear the flat select
      $("#which-flat")[0].sumo.unSelectAll();
      $("#which-flat").empty();

      // Add flat names as selected options, with actual flat IDs as values
      flats.forEach((flatName, index) => {
        const actualFlatId = flatIds[index] || "";
        $("#which-flat").append(
          `<option value="${$("<div>").text(actualFlatId).html()}" selected>${$(
            "<div>",
          )
            .text(flatName)
            .html()}</option>`,
        );
      });

      $("#which-flat")[0].sumo.reload();
    }
  }

  // Handle checkbox change
  $(document).on("change", ".js-custom-flat-selector", function () {
    const checkbox = $(this);
    const flatId = checkbox.attr("id");
    const row = checkbox.closest(".js-custom-flat-row");

    if (checkbox.prop("checked")) {
      // Add to selection
      if (!customSelectedFlats.includes(flatId)) {
        customSelectedFlats.push(flatId);
      }
      row.addClass("selected");
    } else {
      // Remove from selection
      customSelectedFlats = customSelectedFlats.filter((id) => id !== flatId);
      row.removeClass("selected");
    }

    syncWithLakaskereso();
    updateSelectedCounter();
  });

  // Handle offer button click - we control the modal opening manually
  $(document).on("click", ".js-custom-offer-button", function (e) {
    // Always prevent default and stop all event handlers
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Check if at least one flat is selected
    if (customSelectedFlats.length === 0) {
      if ($.showError) {
        $.showError(
          localize.translations.selectOneFlat ||
            "Kérjük legalább egy lakást válasszon ki!",
        );
      } else {
        alert(
          localize.translations.selectOneFlat ||
            "Kérjük legalább egy lakást válasszon ki!",
        );
      }
      return false;
    }

    // Update modal content before opening
    updateModalSelectedFlats();

    // Manually open the modal
    $(".js-offer-modal").iziModal("open");

    return false;
  });

  // Also listen to iziModal opening event for safety
  // This prevents the modal from opening if no flats are selected
  $(document).on("opening", ".js-offer-modal", function (e) {
    if ($(".js-custom-flat-table").length) {
      // Only for custom flat list pages
      if (customSelectedFlats.length === 0) {
        // Close the modal immediately if no flats selected
        e.preventDefault();
        $(this).iziModal("close");

        // Show error message
        if ($.showError) {
          $.showError(
            localize.translations.selectOneFlat ||
              "Kérjük legalább egy lakást válasszon ki!",
          );
        } else {
          alert(
            localize.translations.selectOneFlat ||
              "Kérjük legalább egy lakást válasszon ki!",
          );
        }
        return false;
      }

      // Update modal content if flats are selected
      updateModalSelectedFlats();
    }
  });

  // Handle row click (anywhere except the "Érdekel" checkbox and the 3D tour button)
  $(document).on("click", ".js-custom-flat-row", function (e) {
    const $target = $(e.target);

    if (
      $target.closest(
        ".checkbox-item, .js-tour-link, .js-gallery-fancybox-trigger",
      ).length
    ) {
      return;
    }

    const galleryTrigger = $(this).find(".js-gallery-fancybox-trigger")[0];

    if (galleryTrigger) {
      galleryTrigger.click();
    }
  });
})(jQuery);
